export default {
  props: {
    google: Object,
    map: Object,
    center: Object,
    radius: [Number, String]
  },
  data () {
    return {
      circle: null
    }
  },
  mounted () {
    this.drawCircle()
  },
  destroyed () {
    if (this.circle) this.circle.setMap(null)
  },
  methods: {
    drawCircle () {
      const options = {
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        map: this.map,
        center: this.center,
        radius: parseInt(this.radius, 10) || 0
      }
      this.circle = new this.google.maps.Circle(options)
    }
  },
  render () {

  }
}
